import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=c54f4218"
import script from "./PercentageBar.vue?vue&type=script&lang=js"
export * from "./PercentageBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports